import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateNuisances } from '@store/slice/missionSlice'
import { updateNotification, updateData } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDynamicForm from '@hook/useDynamicForm'
import useDeleteButton from '@hook/useDeleteButton'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const ListNuisances = () => {
  const { mission } = useSelector(state => state.main)
  const { nuisances } = useSelector(state => state.mission)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const toggleDynamicForm = useDynamicForm()
  const deleteButton = useDeleteButton()
  const [t] = useTranslation('common')

  const dataNuisances = { nodes: [] }
  if (nuisances) {
    dataNuisances.nodes = Object.values(nuisances)
  }

  const removeNuisance = nuisance => {
    const { id, links } = nuisance
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code === 200) {
        const nuisance = nuisances[id]
        const nuisancesList = { ...nuisances }
        delete nuisancesList[id]
        dispatch(updateNuisances({ ...nuisancesList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: nuisance.label }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/nuisances`, response => {
      const { code, options, nuisances } = response
      if (code === 200) {
        dispatch(updateNuisances(nuisances))
        dispatch(updateData({ nuisances: options }))
      }
    })
  }, [])

  return (
    <Div cssClass='users-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('nuisance', null),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('titles.nuisances_list')}</h2>
      {null !== nuisances && dataNuisances.nodes.length
        ? <>
          <Table data={dataNuisances} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>ID</HeaderCell>
                    <HeaderCell>{t('table.Name')}</HeaderCell>
                    <HeaderCell>{t('table.IsActive')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.id}</Cell>
                      <Cell>{item.label}</Cell>
                      <Cell>{item.isActive ? t('labels.yes') : t('labels.no')}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => toggleDynamicForm('nuisance', null, item)
                          }
                        ]} />
                        {deleteButton(item, item.name, removeNuisance)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListNuisances